"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COAddressHelpers = void 0;
const types_1 = require("./types");
const DefaultAddressHelpers_1 = require("../DefaultAddressHelpers");
const utils_1 = require("./utils");
class StaticCoAddressHelpers extends DefaultAddressHelpers_1.StaticAddressHelpers {
    static formatAddress(address) {
        const addressTypes = {
            [types_1.AddressCategoryEnum.STANDARD]: (0, utils_1.formatStandardAddress)(address),
        };
        return addressTypes[address.addressType] || (0, utils_1.formatStandardAddress)(address);
    }
    static validateAddress(address) {
        return Boolean(address);
    }
}
StaticCoAddressHelpers.standardRegex = /^[\sA-Za-z0-9-',./]+$/;
StaticCoAddressHelpers.cityRegex = /^[A-Za-z\s.'-]*$/;
class COAddressHelpers extends StaticCoAddressHelpers {
    constructor() {
        super(...arguments);
        this.standardRegex = COAddressHelpers.standardRegex;
        this.cityRegex = COAddressHelpers.cityRegex;
    }
    formatAddress(address) {
        return COAddressHelpers.formatAddress(address);
    }
    validateAddress(address) {
        return COAddressHelpers.validateAddress(address);
    }
}
exports.COAddressHelpers = COAddressHelpers;
//# sourceMappingURL=COAddressHelpers.js.map